<app-navbar></app-navbar>
<section class="section-padding contact-top bg-light-theme">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-sm-6">
                <div class="contact-info-box mb-md-40">
                    <i class="fas fa-map-marker-alt"></i>
                    <h6 class="text-theme fw-600">LA Burgers and Shakes Johnston
                        <br>Shop 5, Johnston Central,1 Lind Rd, Johnston NT 0832</h6>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6">
                <div class="contact-info-box mb-md-40">
                    <i class="fas fa-phone-alt"></i>
                    <h6 class="text-theme fw-600"><a href="#" class="text-theme">08 8914 6796</a><br> Weekdays: 11:00am - 10:00pm
                    <br>Weekend: 11:00am - 10:00pm
                    </h6>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6">
                <div class="contact-info-box mb-md-40">
                    <i class="fas fa-envelope"></i>
                    <h6 class="text-theme fw-600"><a href="#" class="text-theme">info@laburgersandshakes.com.au</a><br> 24 X 7 online
                        support
                    <br> <span class="" style="color: white;">11:00am - 10:00pm</span> 
                    </h6>
                </div>
            </div>
            <!-- <div class="col-lg-4 col-sm-6">
                <div class="contact-info-box mb-md-40">
                    <i class="fas fa-envelope"></i>
                    <h6 class="text-theme fw-600"><a href="#" class="text-theme">info@laburgersandshakes.com.au</a><br> 24 X 7 online
                        support</h6>
                </div>
            </div> -->
        </div>
    </div>
</section>
<section class="section-padding contact-form">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-header-left title">
                    <h3 class="text-light-black header-title">Get In Touch</h3>
                </div>
                <form (ngSubmit)="onSubmit(contactForm)" #contactForm="ngForm">

                    <div class="row">
                  
                      <!-- NAME -->
                      <div class="col-md-6">
                        <div class="form-group">
                          <input type="text" name="name" [(ngModel)]="model.name" #name="ngModel"
                                 class="form-control" placeholder="Name" required>
                  
                          <!-- Required shows on submit OR touch -->
                          <div *ngIf="name.invalid">
                            <div *ngIf="(submitted || name.touched) && name.errors?.required" class="text-danger">
                              Name is required
                            </div>
                          </div>
                        </div>
                  
                        <!-- EMAIL -->
                        <div class="form-group">
                          <input type="email" name="email" [(ngModel)]="model.email" #email="ngModel"
                                 class="form-control" placeholder="Email" required email>
                  
                          <div *ngIf="email.invalid">
                  
                            <!-- Required only -->
                            <div *ngIf="(submitted || email.touched) && email.errors?.required" class="text-danger">
                              Email is required
                            </div>
                  
                            <!-- Email format shown only after user types -->
                            <div *ngIf="email.touched && email.errors?.email" class="text-danger">
                              Invalid email format
                            </div>
                  
                          </div>
                        </div>
                  
                        <!-- PHONE -->
                        <div class="form-group">
                          <input type="text" name="phone" [(ngModel)]="model.phone" #phone="ngModel"
                                 class="form-control" placeholder="Phone No." required pattern="^[0-9]{10}$">
                  
                          <div *ngIf="phone.invalid">
                  
                            <!-- Required only -->
                            <div *ngIf="(submitted || phone.touched) && phone.errors?.required" class="text-danger">
                              Phone number is required
                            </div>
                  
                            <!-- Pattern error only after typing -->
                            <div *ngIf="phone.touched && phone.errors?.pattern" class="text-danger">
                              Phone must be 10 digits
                            </div>
                  
                          </div>
                        </div>
                  
                        <!-- SUBJECT -->
                        <div class="form-group">
                          <input type="text" name="subject" [(ngModel)]="model.subject" #subject="ngModel"
                                 class="form-control" placeholder="Subject" required>
                  
                          <div *ngIf="subject.invalid">
                            <div *ngIf="(submitted || subject.touched) && subject.errors?.required" class="text-danger">
                              Subject is required
                            </div>
                          </div>
                        </div>
                      </div>
                  
                      <!-- MESSAGE -->
                      <div class="col-md-6">
                        <div class="form-group">
                          <textarea name="message" [(ngModel)]="model.message" #message="ngModel"
                                    class="form-control" placeholder="Message"
                                    required minlength="5"></textarea>
                  
                          <div *ngIf="message.invalid">
                  
                            <!-- Required only -->
                            <div *ngIf="(submitted || message.touched) && message.errors?.required" class="text-danger">
                              Message is required
                            </div>
                  
                            <!-- Minlength after typing -->
                            <div *ngIf="message.touched && message.errors?.minlength" class="text-danger">
                              Message must be at least 5 characters
                            </div>
                  
                          </div>
                        </div>
                      </div>
                  
                      <!-- SUBMIT -->
                      <div class="col-12">
                        <button type="submit" class="btn btn-primary">
                          Submit
                        </button>
                      </div>
                  
                    </div>
                  </form>
                  
                  
                  
                  
            </div>

        </div>
    </div>
    <div class="contact-map mt-3">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3895.36715964819!2d131.0036247759871!3d-12.491805650348551!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2cc0a38073a313fd%3A0x88024ad624d32c71!2sLA%20Burgers%20and%20Shakes!5e0!3m2!1sen!2sin!4v1765177754013!5m2!1sen!2sin%22 " height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        <!-- <iframe
           
        src="https://maps.google.com/maps?q=university%20of%20san%20francisco&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed">
    </iframe> -->
    </div>
</section>

<app-footer1></app-footer1>